/**
 * Cookie helpers, replacing angular's `$cookies`. Name and value are percent encoded exactly the
 * way ngCookies did it, so cookies written before the migration are still readable.
 */

function safeDecodeURIComponent (value) {
    try {
        return decodeURIComponent(value);
    } catch (e) {
        return value; // ignore a malformed cookie, like angular's cookie reader did
    }
}

function getCookie (name) {
    const encodedName = encodeURIComponent(name);
    for (const cookie of document.cookie.split(';')) {
        const separatorIndex = cookie.indexOf('=');
        if (separatorIndex === -1) {
            continue;
        }
        if (safeDecodeURIComponent(cookie.slice(0, separatorIndex).trim()) === safeDecodeURIComponent(encodedName)) {
            return safeDecodeURIComponent(cookie.slice(separatorIndex + 1));
        }
    }
    return undefined;
}

/**
 * @param name {String}
 * @param value {*} stringified, like `$cookies.put` did
 * @param options {Object} [{expires, path, domain, secure}], `expires` is a Date or a string.
 *                Leaving `path` out keeps the browser default (the current directory), which is
 *                what the angular version did too.
 */
function setCookie (name, value, { expires, path, domain, secure } = {}) {
    let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
    if (expires) {
        cookie += `;expires=${expires instanceof Date ? expires.toUTCString() : expires}`;
    }
    if (path) {
        cookie += `;path=${path}`;
    }
    if (domain) {
        cookie += `;domain=${domain}`;
    }
    if (secure) {
        cookie += ';secure';
    }
    document.cookie = cookie;
}

function removeCookie (name, options = {}) {
    setCookie(name, '', { ...options, expires: 'Thu, 01 Jan 1970 00:00:00 GMT' });
}

export { getCookie, setCookie, removeCookie };
